<template>
  <div class="success-container" v-if="show">
    <img :src="require('@/assets/images/icon_successx.png')" alt="">
    <span class="span1">
        <slot ></slot>
    </span>
    
  </div>
</template>
<script>
export default {
  data(){
    return {
      show:true
    }
  },
  created(){
    setTimeout(()=>{
      this.show = false;
      this.$parent.error(false);
    },1500)
  }
}
</script>
<style lang="scss" scoped>
.success-container{
  z-index: 20010;
  background: #ffffff;
  @include abs-c;
  position: fixed;
  height: 104px;
  width: 104px;
  border-radius: 8px;
  box-shadow: 0px 0px 13px #fff3f3;
  @include flex-d-c;
  font-size: 14px;
  color: #808080;
  align-items: center;
  img{

  }
}
.span1{
  text-align: center;
  padding: 0 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/error.vue